<!-- 主页面 -->
<template>
  <div class="image dashboard">
    <!--  Welcome back  -->
    <!-- 欢迎使用云平台 -->
    <p class="title">{{$I18n("welcome_use_cloud")}}</p>
    <md-card>
      <md-card-content>
        <div style="display: flex;">
          <div class="plat-qa">{{$I18n("plat_guide")}}</div>
          <div class="select-box">
            <div @click="() => goDoc('dev')">{{$I18n("product_deve")}}</div>
            <div @click="() => goDoc('guide')">{{$I18n("app_deve")}}</div>
            <div @click="() => goDoc('cloud')">{{$I18n("cloud_deve")}}</div>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <!-- 产品开发 -->
    <md-card v-if="productList.length > 0 && hasMenu(300, 305)">
      <md-card-content>
        <div>
          <p class="title">{{$I18n("product_deve")}}</p>
          <div class="right-button">
            <div class=" md-size-50 white-button" @click="() => goProduct()">{{$I18n("go_product_deve")}}</div>
          </div>
          <div class="md-layout">
            <div v-for="item in productList" :key="item.id" @click="() => goProduct(item)" class="md-layout-item md-size-33 md-xsmall-size-100">
              <md-card>
                <!-- 卡片主体-设备信息 -->
                <md-card-content>
                  <div class="md-layout card-form">
                    <!-- 左侧-设备图片 -->
                    <div class="md-layout-item md-size-25 product-card-img">
                      <img :src="item.img"/>
                    </div>
                    <!-- 右侧-文字说明 -->
                    <div class="md-layout-item md-size-75 no-right-padding">
                      <!-- 设备名字 -->
                      <p class="weight-font">{{item.name}}</p>
                      <!-- 节点类型{1:多通道, 2:设备} -->
                      <p class="product-card-p" :style="{'margin-right':'8px'}">
                        {{item.node_type == 2 ?$I18n("device") :$I18n("gateway") }}
                      </p>
                      <!-- 类型名称 -->
                      <p class="product-card-p">{{$router.history.current.query.lang == 'en' ?item.category_name :item.category_cn_name}}</p>
                      <!-- PK值 -->
                      <p>PK: {{item.pk}}</p>
                      <!-- 创建时间 -->
                      <div :style="{'line-height': '52px'}">
                        {{$I18n("created_thing_time")}}: {{item.create_time.split(" ")[0]}}
                      </div>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <!-- APP&云开发 -->
    <md-card v-if="appList.length > 0 && hasMenu(400, 401)">
      <md-card-content>
        <div>
          <p class="title">{{$I18n("app_cloud_deve")}}</p>
          <div class="right-button">
            <div class=" md-size-50 white-button" @click="() => goApp()">{{$I18n("go_app_cloud_deve")}}</div>
          </div>
          <div class="md-layout">
            <div v-for="item in appList" :key="item.id" @click="() => goApp(item)" class="md-layout-item md-size-33 md-xsmall-size-100">
              <md-card>
                <!-- 卡片主体-设备信息 -->
                <md-card-content>
                  <div class="md-layout card-form">
                    <!-- 右侧-文字说明 -->
                    <div class="md-layout-item md-size-75 no-right-padding">
                      <!-- 设备名字 -->
                      <p class="weight-font">{{item.name}}</p>
                      <!-- 节点类型{1:多通道, 2:设备} -->
                      <p class="app-card-p " :style="{'margin-right':'8px'}">
                        {{item.type_name}}
                      </p>
                      <!-- PK值 -->
                      <p style="margin: 0;">{{item.comp_name}}</p>
                      <!-- 创建时间 -->
                      <div :style="{'line-height': '52px'}">
                        {{$I18n("created_thing_time")}}: {{item.create_time.split(" ")[0]}}
                      </div>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <!-- 数据 -->
    <md-card v-if="hasMenu(600, 601) || hasMenu(600, 605)">
      <md-card-content>
        <div>
          <p class="title">{{$I18n("data_center")}}</p>
          <p class="title" style="font-size: 14px;font-weight: 400;">{{$I18n("data_center_info")}}</p>
          <div class="md-layout" style="margin-top: 20px;">
            <div v-if="hasMenu(600, 601)" class="md-layout-item md-size-30" style="padding-left: 0;padding-right: 20px;">
              <div class=" white-button" @click="() => goInfo('order')">
                <img style="width:24px;margin-right: 4px;" src="/img/dashboard_user.svg">{{$I18n("order_ana")}}
              </div>
            </div>
            <div v-if="hasMenu(600, 605)" class="md-layout-item md-size-30" style="padding-left: 0;padding-right: 20px;">
              <div class=" white-button" @click="() => goInfo('dev')">
                <img style="width:24px;margin-right: 4px;" src="/img/dashboard_data.svg">{{$I18n("dev_ana")}}
              </div>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { timestampToString} from "@/common/tools.js"; // nDaysAgo , 

export default {
  data(){
    return {
      productList: [],
      initAppList: [],
      companyList: [],
      menuList:[],
    }
  },
  computed:{
    appList(){
      return this.initAppList.map(item => {
        let comp = this.companyList.filter(comp => comp.comp_id == item.comp_id)[0];
        let company_name = this.$I18n("unknow")
        if (comp){
          company_name = comp.comp_short_name ?comp.comp_short_name :comp.comp_name;
        }
        let type_name = this.$I18n("unknow")
        switch(item.type){
          case 1: 
            type_name = this.$I18n("test_ver");
            break;
          case 2: 
            type_name = this.$I18n("base_ver");
            break;
          case 3: 
            type_name = this.$I18n("vip_ver");
            break;
        }
        return {
          ...item,
          type_name,
          company_name,
          create_time: timestampToString(item.gmt_create * 1000),
        }
      })
    },
  },
  mounted(){
    this.$api.getMenu({ // api: /user/menu/query
      type : this.UserInfo.role_id != 1 ? 1 : 0,
    })
      .then(this.$Then(res => {
        this.api_getCompData().then(() => {
          this.api_getApp();
          this.api_getPageData()
        });
        this.menuList = res.data;
      }))
      .catch(this.$Catch("", () => {
        this.menuList = [];
      }));  
  },
  methods:{
    hasMenu(mainId, subId){
      let menuItem = this.menuList.filter(menu => {
        return menu.menu_id === mainId
      })[0]
      if(menuItem){
        let subMenuItem = menuItem.sub_menus ?menuItem.sub_menus.filter(sub => {
          return sub.menu_id === subId
        })[0] :null
        if(subMenuItem){
          return true
        }
      }
      return false
    },
    goInfo(name){
      this.$router.push({ path: '/info/'+name, query: { lang: this.$router.history.current.query.lang }})
    },
    goDoc(name){
      window.location.href = "http://docs.kdzn.top/" 
        + (this.$router.history.current.query.lang === "en" ?"en/" :"zh/") 
        + name
    },
    goProduct(product){
      this.$router.push({ path: '/product/product_list', query: { lang: this.$router.history.current.query.lang, ...(product ?{id: product.id } :{})  }})
    },
    goApp(app){
      this.$router.push({ path: '/applist/app', query: { lang: this.$router.history.current.query.lang, ...(app ?{id: app.id } :{}) }})
    },
    api_getCompData(){
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.companyList = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.companyList = [];
        }));
    },
    api_getApp(){ // API-获取APP列表
      this.$api.queryAppBase({ // api: /user/app/query
        comp_id   : this.UserInfo.comp_id,
        page_no   : 1,
        page_size : 3,
      })
        .then(this.$Then(res => {
          this.initAppList = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.initAppList = [];
        }));
    },
    api_getPageData(){ // API-获取页面数据
      // 云存储订单信息
      this.$api.getProduct({ // api: /user/product/get
        comp_id: this.UserInfo.comp_id,
        page_size: 3,
        page_no: 1,
      })
        .then(this.$Then(res => {
          this.productList = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.productList = [];
        }));
    },
  },
};
</script>
<style lang="scss" scoped>
  .right-button{
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .white-button{
    padding: 0 20px;
    line-height: 32px;
    border-radius: 4px;
    border: 1px solid #ddd;
    text-align:center;
    transition: box-shadow .2s;
    cursor:pointer;
    font-weight: 400;
  }
  .md-layout-item .white-button{
    line-height: 60px;
    margin: 0;
  }
  .white-button:hover{
    box-shadow: 1px 1px 1px #c9c9c994;
  }
  .dashboard{
    overflow:auto;
  }
  .plat-qa{
    border-right: 1px solid #aaa;
    padding: 10px 20px 10px 5px;
    margin-right:10px;
    font-weight:600;
    font-size: 17px;
  }
  .title{
    font-weight:600;
    font-size: 17px;
  }
  .select-box{
    display:flex;
  }
  .app-card-p {
    color: #000;
    display: inline;
    position: absolute;
    top: 0px;
    right: 0;
    padding: 6px 12px;
    border-radius : 4px;
    font-weight: 400;
  }
  .select-box>div{
    margin-left: 10px;
    margin-right: 10px;
    padding: 10px;
    font-weight:400;
    font-size: 14px;
    border-radius: 6px;
    background: #f8f8f8;

    cursor:pointer;
  }
  .image{
    // height: 700px;
    color: #555;
    clear: both;
    background-repeat: no-repeat;
    background-size: cover;
    margin-left: 30px;

    // line-height: 650px;
    // background-image: url(/img/welcome.jpg);
    // text-align: center;
    // font-size: 60px;
  }
  @media screen and ( max-width: 600px ){
    .image{
      font-size: 48px;
      height: calc( 100vh - 132px);
      line-height: calc( 100vh - 182px );
    }
  }
  .md-layout-item .version {
    transition: all 0s;
  }
  .line{
    content: "";
    height: 1px;
    width: calc(100% - 15px);
    background-color: rgba(180, 180, 180, 0.3);
  }
  .sec-side{
    font-size: 16px;
    font-weight: 300;
    height: 70px;
    width: 200px;
    box-sizing: border-box;
    padding: 15px 12px;
    line-height: 40px;
  }
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    // width: calc( 100% - 15px );
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }

  .tabs-content{
    width : 200px;
    box-shadow : none;
    border-right : 1px solid #ddd;
    border-radius: 0;
    margin-right : 18px;
  }
  .product-card-img{
    display: flex;
    align-items: center;
    padding-left: 0;
  }
  .product-card-img img{
    flex-shrink : 0;
  }
  .product-card-p {
    background-color: #eeeeee;
    display: inline;
    padding: 6px 12px;
    border-radius : 4px;
    font-weight: 400;
  }
  .tabs-contant{
    padding-top : 40;
    width: calc(100% - 240px);
    box-shadow: none;
  }
  .left-table {
    text-align: left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    margin-right : 16px;
  }
  .card-form {
    margin-top: 0;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
